import React from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../../../service";
import { DynamicFileThumbnail } from "../../../../lms-shared/functions/DynamicFileThumbnail";
import classes from './UploadAuxiliary.module.css';

const UploadStep1 = ({ auxiliary, setAuxiliary, setStep }) => {

    const texts = useSelector(state => state.translate.texts);

    const convertUrlToFile = async (url, fileName) => {
        const response = await fetch(url);
        const blob = await response.blob()
        return new File([blob], fileName)
    }

    const uploadFile = async e => {
        const file = e.target.files?.[0];
        if (!file) return;
        let fileExtension = file.name.split('.').at(-1);
        switch (fileExtension?.toLowerCase()) {
            case 'gif':
            case 'jpeg':
            case 'png':
            case 'jpg':
                setAuxiliary({ ...auxiliary, file, thumbnail: file })
                break;
            default:
                const thumbnail = await convertUrlToFile(DynamicFileThumbnail(file.name, null), 'thumbnail.png')
                setAuxiliary({ ...auxiliary, file, thumbnail })
        }
    }

    const enterURL = async e => {
        const url = e.target.value;
        try {
            new URL(url);
            const fileName = url.split('/').at(-1);
            const thumbnailUrl = DynamicFileThumbnail(fileName, url.split(fileName)[0]);
            const file = await convertUrlToFile(url, fileName)
            const thumbnail = await convertUrlToFile(thumbnailUrl, 'thumbnail.png')
            setAuxiliary({ ...auxiliary, file, thumbnail });
        } catch (err) {
            console.log('err not valid URL', err)
        }
    }

    const changeThumbnail = e => {
        setAuxiliary({ ...auxiliary, thumbnail: e.target.files[0] })
    }

    return (
        <div className={classes.UploadAuxiliaryContainer}>
            <div className={classes.Title}>{texts.uploadAuxiliary}</div>
            <div className={classes.UploadAuxiliary}>
                <input type='text' placeholder={texts.giveLinkOrUpload} name="newAuxiliaryLink" className={classes.Input} onChange={enterURL} />
                <label htmlFor="newAuxiliaryFile" className={classes.ImportBtn}>{texts.importFromComputer}</label>
            </div>
            <input type='file' id='newAuxiliaryFile' name="newAuxiliaryFile" className={classes.InputFile} onChange={uploadFile} />
            <div className={`${classes.Title} ${classes.OpeningImageTitle}`}>{texts.openingImage}</div>
            <div className={classes.UploadAuxiliaryOpeningImage}>
                {auxiliary?.thumbnail ? <img className={classes.OpeningImage} src={URL.createObjectURL(auxiliary.thumbnail)} alt="thumbnail" /> : ''}
                <label htmlFor="openingImageFile" className={classes.ImportBtn}>{texts.changeImage}</label>
            </div>
            <input type='file' id="openingImageFile" name="newAuxiliaryOpeningImgFile" className={classes.InputFile} accept="image/*" onChange={changeThumbnail} />
            <input type='text' placeholder={texts.giveNewName2} name="newAuxiliaryName" className={`${classes.Input} ${classes.InputText}`} defaultValue={auxiliary?.name} onChange={e => setAuxiliary({ ...auxiliary, name: e.target.value })} />
            <textarea placeholder={texts.giveDescription} name="newAuxiliaryDesc" className={classes.TextArea} defaultValue={auxiliary?.desc} onChange={e => setAuxiliary({ ...auxiliary, desc: e.target.value })} />
            <div className={`${classes.ImportBtn} ${classes.Btn}`} onClick={() => setStep(2)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setStep(2))}>{texts.continue}</div>
        </div>
    )
}

export default UploadStep1;